<template>
  <div class="StudentQuestionForm">
    <h2 class="gl_form-title small">
      {{ t('hiring.student-question.form-legend') }}
    </h2>

    <p class="hiring-subtitle">
      {{ t('hiring.student-question.subtitle') }}
    </p>

    <RadioButtonGroup
      id="student-question"
      :value="studentQuestion"
      v-model="studentQuestion"
      :options="studentQuestionOptions"
      flexDirection="row"
      :rules="[validationRules.radioRequired]"
    >
    </RadioButtonGroup>
  </div>
</template>
<script lang="ts" setup>
  import { ref } from 'vue'
  import { useI18n } from 'vue-i18n'
  import RadioButtonGroup from '@/modules/core/components/ui/RadioButtonGroupComponent.vue'
  import { useRules } from '@/modules/core/composables/useRulesComposable'
  import type { OptionsValuesInterface } from '@/modules/core/models/types'

  const { t } = useI18n()
  const { required } = useRules()
  defineExpose({ triggerSubmit })

  interface PropsInterface {
    nextForm: String[]
    answers: Record<string, any>
    configurations: Record<string, any>
    extra?: Record<string, any>
  }

  const props = withDefaults(defineProps<PropsInterface>(), {})
  const currentInsured = props.answers.currentInsured
  const firstStudentQuestionValue =
    currentInsured.studentSituation === 'S' || currentInsured.studentSituation === 'N'
      ? currentInsured.studentSituation
      : null

  const studentQuestion = ref(firstStudentQuestionValue)

  const studentQuestionOptions: OptionsValuesInterface[] = [
    { label: t('common.choices.yes'), value: 'S' },
    { label: t('common.choices.no'), value: 'N' }
  ]

  const validationRules = {
    radioRequired: (value: string) => required(value, 'common.validations.option')
  }

  function getNextPage() {
    const index = studentQuestion.value === 'S' ? 0 : 1
    const nextPage = props.nextForm[index]
    return nextPage
  }

  async function triggerSubmit() {
    const page = getNextPage()
    currentInsured.studentSituation = studentQuestion.value!

    const answers = props.extra?.customInsuredProp
      ? { [props.extra.customInsuredProp]: currentInsured }
      : props.extra?.currentInsuredIndex === 'holder'
      ? { holder: currentInsured }
      : currentInsured

    return { page, answers }
  }
</script>
<style lang="scss" scoped>
.StudentQuestionForm {
  .hiring-subtitle {
    margin-bottom: $spacing-xl;
    color: $color-neutral;
    font-size: $font-size-l;
    font-weight: $font-weight-400;
  }
}
</style>
